import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiEndpoint } from './base-endpoint';
import { PaginatedResponse } from 'src/app/modules/support/tickets/models/ticket.interfaces';

export interface GroupedUsersParams {
  page?: number;
  perPage?: number;
  search?: string;
}

export interface GroupedUsersFilterParams {
  page?: number;
  perPage?: number;
  search?: string;
  institutionInterfaceIds: number[];
}

export class UserGroupEndpoint extends BaseApiEndpoint {
  getUsersGroupedByUserGroup(
    groupId: number,
    params?: GroupedUsersParams,
  ): Observable<PaginatedResponse<any>> {
    let httpParams = new HttpParams();

    if (params?.page !== undefined) {
      httpParams = httpParams.set('page', String(params.page));
    }

    if (params?.perPage !== undefined) {
      httpParams = httpParams.set('per_page', String(params.perPage));
    }

    if (params?.search !== undefined && params.search !== '') {
      httpParams = httpParams.set('search', params.search);
    }

    return this._http.get<PaginatedResponse<any>>(
      `${this.path}user-groups/${groupId}/grouped-users`,
      { params: httpParams },
    );
  }

  getUsersGroupedByUserGroupFiltered(
    groupId: number,
    params: GroupedUsersFilterParams,
  ): Observable<PaginatedResponse<any>> {
    return this._http.post<PaginatedResponse<any>>(
      `${this.path}user-groups/${groupId}/grouped-users/filter`,
      {
        perPage: params.perPage ?? 50,
        search: params.search ?? '',
        institutionInterfaceIds: params.institutionInterfaceIds,
        page: params.page ?? 1,
      },
    );
  }

  getUserGroupsByToken(): Observable<any> {
    return this._http.get<any>(`${this.path}user-groups`);
  }

  getTraffic(): Observable<any> {
    return this._http.post<any>(`http://infistel.pe.devel/api/monitor-router/1`, {}, {});
  }
}
